import type { ApiProxyClient } from '../../types';
import { getDiscountDetails } from './getDiscountDetails';

export const discountsApi: ApiProxyClient['discounts'] = {
    getDiscountDetails,
};
